import { render, staticRenderFns } from "./WebsiteCrud.vue?vue&type=template&id=6fd48e7c"
import script from "./WebsiteCrud.vue?vue&type=script&lang=js"
export * from "./WebsiteCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports